module.exports = __webpack_public_path__ + "img/14.7.Chla.2274ac50.png";